const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ'; // sem I, O ambíguos
const LOWER = 'abcdefghjkmnpqrstuvwxyz'; // sem i, l, o
const DIGITS = '23456789'; // sem 0, 1
const SYMBOLS = '!@#$%&*+=?_-';

const DEFAULT_LENGTH = 16;

function pick(set: string): string {
  const idx = secureRandomInt(set.length);
  return set.charAt(idx);
}

function secureRandomInt(maxExclusive: number): number {
  if (maxExclusive <= 0) throw new Error('maxExclusive must be > 0');
  const max = Math.floor(maxExclusive);
  // rejection sampling pra evitar viés modulo
  const range = 256 - (256 % max);
  const buf = new Uint8Array(1);
  while (true) {
    crypto.getRandomValues(buf);
    const v = buf[0]!;
    if (v < range) return v % max;
  }
}

function shuffleSecure<T>(arr: T[]): T[] {
  const out = [...arr];
  for (let i = out.length - 1; i > 0; i -= 1) {
    const j = secureRandomInt(i + 1);
    [out[i], out[j]] = [out[j]!, out[i]!];
  }
  return out;
}

/**
 * Gera senha forte via Web Crypto API.
 * Garante 1+ de cada classe e embaralha posições. Default 16 chars.
 */
export function generateStrongPassword(length: number = DEFAULT_LENGTH): string {
  const required = [pick(UPPER), pick(LOWER), pick(DIGITS), pick(SYMBOLS)];
  const alphabet = UPPER + LOWER + DIGITS + SYMBOLS;
  const rest: string[] = [];
  for (let i = required.length; i < length; i += 1) rest.push(pick(alphabet));
  return shuffleSecure([...required, ...rest]).join('');
}
